import type { DetalheDaOs } from '../../../types/ordemDeServico'
import { linhasDaSecao4, totaisDaSecao4 } from './linhasDaOs'
import { DOCUMENTO_DA_OS as T } from './textoDaOs'

/** O quadro da seção 4, com a fração como o documento a escreve. */
export function QuadroDeServicos({ ordem }: { ordem: DetalheDaOs }) {
  const linhas = linhasDaSecao4(ordem.itens)
  return (
    <table className="os-tabela">
      <caption className="sr-only">Especificação dos serviços e volumes estimados</caption>
      <thead>
        <tr>
          <th scope="col">{T.quadro.item}</th>
          <th scope="col">{T.quadro.descricao}</th>
          <th scope="col">{T.quadro.metrica}</th>
          <th scope="col">{T.quadro.valorUnitario}</th>
          <th scope="col">{T.quadro.quantidade}</th>
          <th scope="col">{T.quadro.valorTotal}</th>
        </tr>
      </thead>
      <tbody>
        {linhas.map((linha) => (
          <tr key={linha.item}>
            <td>{linha.item}</td>
            <td>
              {linha.descricao}
              {linha.conferencia && <span style={{ display: 'block', fontSize: '8.5pt' }}>{linha.conferencia}</span>}
            </td>
            <td>{linha.metrica}</td>
            <td className="os-numero">{linha.valorUnitario}</td>
            <td className="os-numero">{linha.quantidade}</td>
            <td className="os-numero">{linha.valorTotal}</td>
          </tr>
        ))}
        {totaisDaSecao4(ordem).map((total) => (
          <tr key={total.rotulo}>
            <th scope="row" colSpan={5}>
              {total.rotulo}
            </th>
            <td className="os-numero">{total.valor}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
